export const PROJECTS_FILTER_KEY_SEARCH = 'searchString';
export const PROJECTS_FILTER_KEY_STATUS = 'status';
export const PROJECTS_FILTER_KEY_BILLING_MODEL = 'billingModel';
export const PROJECTS_FILTER_KEY_PROBABILITY = 'probability';
export const PROJECTS_FILTER_KEY_MANAGER = 'manager';

export const PROJECTS_TABLE_FILTER_KEYS = [
  PROJECTS_FILTER_KEY_SEARCH,
  PROJECTS_FILTER_KEY_STATUS,
  PROJECTS_FILTER_KEY_BILLING_MODEL,
  PROJECTS_FILTER_KEY_PROBABILITY,
  PROJECTS_FILTER_KEY_MANAGER,
];

export const PROJECTS_TABLE_FILTERS_STORAGE_KEY = 'projects-table-filters';
